<template>
  <div class="ruKuZuoyeWarp-body app-container">
    <el-breadcrumb separator-class="el-icon-arrow-right" >
      <el-breadcrumb-item :to="{ path: '/inventoryOrder' }">返回</el-breadcrumb-item>
      <el-breadcrumb-item>新建建材</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 查询条件 -->
    <div ref="searchBox" class="formBox margbot">
      <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="95px" size="mini" style="width: 100%;">
        <div class="formItemBox">
        <el-form-item label="仓位名称:">
          <el-input v-model="formData.warehouseName" size="mini" placeholder="请选择仓位名"></el-input>
        </el-form-item>
        <el-form-item label="货物类型:">
          <el-select v-model="formData.productType" clearable @change="productTypeChange" placeholder="请选择" filterable size="mini">
            <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName" :value="item.productType">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产地:">
          <el-select v-model="formData.steelMillName" @change='steelMillNameChange' clearable placeholder="请选择" filterable size="mini">
            <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规格:">
          <el-select v-model="formData.specification" clearable @change='specificationChange' placeholder="请选择" filterable size="mini">
            <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="材质:">
          <el-select v-model="formData.model" @change="modelChange" clearable placeholder="请选择" filterable size="mini">
            <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
       </div>
        <el-form-item>
          <el-button type="primary" size="mini" v-if="btnFlg[0]" @click="chaxun">查询</el-button>
          <el-button type="primary" size="mini" v-if="btnFlg[1]" @click="chongzhi">重置</el-button>
          <el-button type="primary" size="mini" v-if="btnFlg[2]" @click="exportClick">导出</el-button>
          <el-button type="primary" size="mini" v-if="btnFlg[3]" @click="anquanmao">安全帽盘库</el-button>
          <el-button type="primary" size="mini" v-if="btnFlg[4]" @click="putong">普通盘库</el-button>
        </el-form-item>
        <el-form-item>
          <span style="margin-left: 15px">
            总件数:
            <span style="color: red">{{ totalNumber }}</span> &nbsp;件
          </span>
          <span>
            总重量:
            <span style="color: red">{{Number(totalAllWeight)}}</span> &nbsp;吨
          </span>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData" style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row>
        <el-table-column fixed type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column fixed width="100" label="操作" align="center">
          <template v-slot='scope'>
            <el-button type="text" @click="deleteRow(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="仓库名称" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位名称" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量（吨）" align="center"></el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="weight" label="收费标准" align="center"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="stockPoundWeight" label="费用" width="120" align="center"></el-table-column> -->
      </el-table>
    </div>
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getInventoryJFList,
  getInventoryJFNumber,
  getRelationCustomer,
  addInventoryThread,
  zidianKuwei,
  getVirtualBalingList
} from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import { exportExcel } from '@/utils/fileDown.js'
import { getBtn } from '@/utils/getButton'
export default {
  data () {
    return {
      formData: {
        warehouseName: '',
        productType: '',
        steelMillName: '',
        specification: '',
        model: ''
      },
      cargoBarcodes: '',
      RKData: [],
      productTypeData: [],
      steelMillNameData: [],
      specificationData: [],
      modelData: [],
      inventoryTypeData: [
        {
          id: 0,
          name: '卷板'
        },
        {
          id: 1,
          name: '建材'
        }
      ],
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      addKuwei: [],
      totalAllWeight: 0,
      totalNumber: 0,
      h: '500px',
      tableData: [],
      btnArr: [
        '003P010201',
        '003P010202',
        '003P010203',
        '003P010204',
        '003P010205'
      ],
      btnFlg: [],
      total: 0,
      delWarehouseIds: []
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 200 + 'px'
    this.getRelationCustomerS()
    this.zidianKuweiS()
  },
  created () {
    this.btnFlg = getBtn(this.btnArr)
    this.delWarehouseIds = []
    this.getVirtualBalingList()
  },
  methods: {
    // 改变客户
    changeKH () {
      console.log(123)
      this.delWarehouseIds = []
    },
    getInventoryJFList () {
      console.log(this.formData.productType, productTypeName)
      const arr = this.delWarehouseIds.join(',')
      let productTypeName
      if (this.formData.productType == '') {
        productTypeName = ''
      } else {
        productTypeName = this.productTypeData.filter(item => item.productType == this.formData.productType)[0].productTypeName
      }
      getInventoryJFList({
        warehouseName: this.formData.warehouseName,
        steelMillName: this.formData.steelMillName,
        productTypeName,
        specification: this.formData.specification,
        model: this.formData.model,
        ...this.pageInfo,
        delWarehouseIds: arr
      }).then(res => {
        console.log(res)
        this.tableData = res.list
        this.total = res.total
      })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    getInventoryJFNumber () {
      const arr = this.delWarehouseIds.join(',')
      let productTypeName
      if (this.formData.productType == '') {
        productTypeName = ''
      } else {
        productTypeName = this.productTypeData.filter(item => item.productType == this.formData.productType)[0].productTypeName
      }
      getInventoryJFNumber({
        warehouseName: this.formData.warehouseName,
        steelMillName: this.formData.steelMillName,
        productTypeName,
        specification: this.formData.specification,
        model: this.formData.model,
        delWarehouseIds: arr
      }).then(res => {
        console.log(res)
        if (res.length == 0) {
          this.totalAllWeight = 0
          this.totalNumber = 0
        } else {
          this.totalAllWeight = res.weight
          this.totalNumber = res.number
        }
      })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chaxun () {
      this.getInventoryJFList()
      this.getInventoryJFNumber()
    },
    chongzhi () {
      this.formData = {
        warehouseName: '',
        productType: '',
        steelMillName: '',
        specification: '',
        model: ''
      }
      this.delWarehouseIds = []
      this.tableData = []
      this.totalAllWeight = 0
      this.totalNumber = 0
      this.total = 0
      this.getVirtualBalingList()
    },
    deleteRow (row) {
      console.log(row)
      this.delWarehouseIds.push(row.stockWarehouseId)
      this.chaxun()
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    // 导出
    exportClick () {
      let productTypeName
      if (this.productTypeData.filter(item => item.productType == this.formData.productType).length > 0) {
        productTypeName = this.productTypeData.filter(item => item.productType == this.formData.productType)[0].productTypeName
      }
      const arr = this.delWarehouseIds.join(',')
      exportExcel(
        this.global.wmsStockName + '/inventory/exportInventoryJFList',
        {
          warehouseName: this.formData.warehouseName,
          steelMillName: this.formData.steelMillName,
          productTypeName,
          specification: this.formData.specification,
          model: this.formData.model,
          delWarehouseIds: arr
        },
        '新建盘库信息表'
      )
    },
    // 提价panku
    anquanmao () {
      if (this.tableData.length == 0) {
        this.$message.error('货物为空，不能下单')
      } else {
        let productTypeName
        if (this.formData.productType == '') {
          productTypeName = ''
        } else {
          productTypeName = this.productTypeData.filter(item => item.productType == this.formData.productType)[0].productTypeName
        }
        const arr = this.delWarehouseIds.join(',')
        addInventoryThread({
          warehouseName: this.formData.warehouseName,
          steelMillName: this.formData.steelMillName,
          productTypeName,
          specification: this.formData.specification,
          model: this.formData.model,
          inventoryHat: 0,
          delWarehouseIds: arr
        }).then(res => {
          console.log(res)
          this.$message.success('创建成功')
          this.$router.push({ name: 'InventoryOrder' })
          this.delWarehouseIds = []
        })
          .catch(error => {
            DonMessage.error(error.message)
          })
      }
    },
    // 提价panku
    putong () {
      if (this.tableData.length == 0) {
        this.$message.error('货物为空，不能下单')
      } else {
        const arr = this.delWarehouseIds.join(',')
        let productTypeName
        if (this.formData.productType == '') {
          productTypeName = ''
        } else {
          productTypeName = this.productTypeData.filter(item => item.productType == this.formData.productType)[0].productTypeName
        }
        addInventoryThread({
          warehouseName: this.formData.warehouseName,
          steelMillName: this.formData.steelMillName,
          productTypeName,
          specification: this.formData.specification,
          model: this.formData.model,
          inventoryHat: 1,
          delWarehouseIds: arr
        }).then(res => {
          console.log(res)
          this.$message.success('创建成功')
          this.$router.push({ name: 'InventoryOrder' })
          this.delWarehouseIds = []
        })
          .catch(error => {
            DonMessage.error(error.message)
          })
      }
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.RKData = res
        })
        .catch((err) => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({})
        .then((res) => {
          this.addKuwei = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      // this.goodsName = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      // this.placeOfOrigin = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      // this.specificationVal = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      // this.modelVal = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    }
  }

}
</script>

<style lang='less' scoped>
.messages {
  font-size: 16px;
}
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
</style>
